<template>
  <div>

    <b-row class='mt-2'>
      <b-col>
        <h4 v-if='item && item.type'>{{item.type.toUpperCase()}}</h4>
      </b-col>
    </b-row>

    <b-row class='mt-2'>
      <b-col>
        <label>Link</label>
        <b-form-input
          :value='item.value.link'
          @input='(e) => actions.handleItemBannerValueChanged(flatPage.id, item.id, "link", e)'
        />
      </b-col>
    </b-row>
    <b-row class='mt-2'>
      <b-col>
        <hr />
      </b-col>
    </b-row>
    <b-row class='mt-2'>
      <b-col>
        <label>Grubość ramki</label>
        <b-form-input
          type='number'
          :value='getProp("banner", "borderWidth", 0)'
          @input='(e) => actions.handleItemBannerStyleChanged(flatPage.id, item.id, "banner", "borderWidth", e)'
        />
      </b-col>
      <b-col>
        <label>Kolor ramki</label>
        <b-form-input
          type='color'
          :value='getProp("banner", "borderColor", "#000000")'
          @input='(e) => actions.handleItemBannerStyleChanged(flatPage.id, item.id, "banner", "borderColor", e)'
        />
      </b-col>
      <b-col>
        <label>Margin top</label>
        <b-form-input
          type='number'
          :value='getProp("banner", "marginTop", 0)'
          @input='(e) => actions.handleItemBannerStyleChanged(flatPage.id, item.id, "banner", "marginTop", e)'
        />
      </b-col>
      <b-col>
        <label>Margin bottom</label>
        <b-form-input
          type='number'
          :value='getProp("banner", "marginBottom", 0)'
          @input='(e) => actions.handleItemBannerStyleChanged(flatPage.id, item.id, "banner", "marginBottom", e)'
        />
      </b-col>
    </b-row>
    <b-row class='mt-2'>
      <b-col>
        <label>Header</label>
        <b-form-input
          :value='item.value.header'
          @input='(e) => actions.handleItemBannerValueChanged(flatPage.id, item.id, "header", e)'
        />
      </b-col>
    </b-row>
    <b-row class='mt-3'>
      <b-col>
        <label>Kolor czcionki</label>
        <b-form-input
          type='color'
          :value='getProp("header", "color", "#000000")'
          @input='(e) => actions.handleItemBannerStyleChanged(flatPage.id, item.id, "header", "color", e)'
        />
      </b-col>
      <b-col>
        <label>Kolor tła</label>
        <b-form-input
          type='color'
          :value='getProp("header", "backgroundColor", "#ffffff")'
          @input='(e) => actions.handleItemBannerStyleChanged(flatPage.id, item.id, "header", "backgroundColor", e)'
        />
      </b-col>
      <b-col>
        <label>Wielkość czcionki</label>
        <b-form-input
          type='number'
          :value='getProp("header", "fontSize", 12)'
          @input='(e) => actions.handleItemBannerStyleChanged(flatPage.id, item.id, "header", "fontSize", e)'
        />
      </b-col>
      <b-col>
        <label>Styl czcionki</label>
        <b-row>
          <b-col>
            <b-form-checkbox
              v-model='headerFontWeight'
              @input='(e) => actions.handleItemBannerStyleChanged(flatPage.id, item.id, "header", "fontWeight", e)'
              value="bold"
              unchecked-value="normal"
            >
              <div style='font-weight: bold'>bold</div>
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox
              v-model='headerFontStyle'
              @input='(e) => actions.handleItemBannerStyleChanged(flatPage.id, item.id, "header", "fontStyle", e)'
              value="italic"
              unchecked-value="normal"
            >
              <div style='font-style: italic'>italic</div>
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class='mt-2'>
      <b-col>
        <hr />
      </b-col>
    </b-row>  
    <b-row class='mt-2'>
      <b-col>
        <label>Sub header</label>
        <b-form-input
          :value='item.value.subheader'
          @input='(e) => actions.handleItemBannerValueChanged(flatPage.id, item.id, "subheader", e)'
        />
      </b-col>
    </b-row>

    <b-row class='mt-3'>
      <b-col>
        <label>Kolor czcionki</label>
        <b-form-input
          type='color'
          :value='getProp("subheader", "color", "#000000")'
          @input='(e) => actions.handleItemBannerStyleChanged(flatPage.id, item.id, "subheader", "color", e)'
        />
      </b-col>
      <b-col>
        <label>Kolor tła</label>
        <b-form-input
          type='color'
          :value='getProp("subheader", "backgroundColor", "#ffffff")'
          @input='(e) => actions.handleItemBannerStyleChanged(flatPage.id, item.id, "subheader", "backgroundColor", e)'
        />
      </b-col>
      <b-col>
        <label>Wielkość czcionki</label>
        <b-form-input
          type='number'
          :value='getProp("subheader", "fontSize", 12)'
          @input='(e) => actions.handleItemBannerStyleChanged(flatPage.id, item.id, "subheader", "fontSize", e)'
        />
      </b-col>
      <b-col>
        <label>Styl czcionki</label>
        <b-row>
          <b-col>
            <b-form-checkbox
              v-model='subheaderFontWeight'
              @input='(e) => actions.handleItemBannerStyleChanged(flatPage.id, item.id, "subheader", "fontWeight", e)'
              value="bold"
              unchecked-value="normal"
            >
              <div style='font-weight: bold'>bold</div>
            </b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox
              v-model='subheaderFontStyle'
              @input='(e) => actions.handleItemBannerStyleChanged(flatPage.id, item.id, "subheader", "fontStyle", e)'
              value="italic"
              unchecked-value="normal"
            >
              <div style='font-style: italic'>italic</div>
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

  import { LOCALES } from '@/utils'
  import {
    handleItemBannerValueChanged,
    handleItemBannerStyleChanged,
  } from '@/store/utils.js'

  export default {
    props: ['flatPage', 'item'],
    methods: {
      getProp(field, key, defaultValue) {
        try {
          return this.item.style && this.item.style[field] && this.item.style[field][key] ? this.item.style[field][key] : defaultValue
        } catch (e) {
          return defaultValue
        }
      },
    },
    data() {
      return {
        actions: {
          handleItemBannerValueChanged,
          handleItemBannerStyleChanged,
        },
        locales: LOCALES,
        headerFontWeight: this.getProp("header", "fontWeight", 'normal'),
        headerFontStyle: this.getProp("header", "fontStyle", 'normal'),
        subheaderFontWeight: this.getProp("subheader", "fontWeight", 'normal'),
        subheaderFontStyle: this.getProp("subheader", "fontStyle", 'normal'),
      }
    },
  }

</script>  